import React from "react";
import PropTypes from "prop-types";
import {
  Type,
  Dialog,
  DialogTitle,
  DialogTitleActions,
} from "@ebscois/react-component-library";
import { DialogContent } from "./_.styled";

export const ReferenceDialog = ({ isOpen, onClose, title, content }) => (
  <Dialog isOpen={isOpen} onRequestClose={onClose} maxWidth="sm">
    <DialogTitle>
      <Type element="h2">{title}</Type>
      <DialogTitleActions onRequestClose={onClose} isFloating />
    </DialogTitle>
    <DialogContent>
      <Type element="span">{content}</Type>
    </DialogContent>
  </Dialog>
);

ReferenceDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};
